import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'
import { Platform, type ViewStyle } from 'react-native'

const webScreenHeight = {
  height: 'var(--app-height, 100dvh)',
  maxHeight: 'var(--app-height, 100dvh)',
} as unknown as ViewStyle

export const useCreateStyles = createStyleSheet((theme) => ({
  root: {
    backgroundColor: theme.COLOR_BG_BASE,
    paddingBottom: 0,
    overflow: 'hidden',
    ...Platform.select({ web: webScreenHeight }),
  },
  header: { height: rh(64), paddingHorizontal: rw(24) },
  operationsHeaderTitle: {
    position: 'absolute',
    left: rw(76),
    right: rw(76),
    top: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  operationsHeaderText: { color: theme.COLOR_TEXT_PRIMARY, fontSize: rf(18), lineHeight: rf(21.6) },
  headerButton: {
    overflow: 'hidden',
    width: rw(40),
    height: rw(40),
    borderRadius: rw(20),
    backgroundColor: theme.COLOR_BG_SURFACE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: { minHeight: 0, overflow: 'hidden', ...Platform.select({ web: { userSelect: 'none' as const } }) },
  content: { paddingHorizontal: rw(24), paddingTop: rh(24), paddingBottom: rh(112) },
  summary: { marginBottom: rh(40) },
  summaryAnimation: { overflow: 'hidden' },
  history: { flex: 1, minHeight: 0 },
  historyScroll: {
    flex: 1,
    minHeight: 0,
    ...Platform.select({ web: { overscrollBehaviorY: 'contain' as const } }),
  },
  card: {
    width: rw(264),
    maxWidth: '100%',
    height: rh(165),
    borderRadius: rw(20),
    overflow: 'hidden',
    ...Platform.select({ web: { scrollSnapAlign: 'center' as const } }),
  },
  carouselViewport: {
    alignSelf: 'stretch',
    marginHorizontal: rw(-24),
    ...Platform.select({ web: { scrollSnapType: 'x mandatory' as const } }),
  },
  cardCarousel: { gap: rw(32), paddingHorizontal: rw(40.5) },
  cardCoverLayer: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 },
  cardOverlay: {
    position: 'absolute',
    left: rw(20),
    right: rw(20),
    top: rh(20),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardNumberBullet: { fontSize: rf(13), lineHeight: rh(18.2) },
  cardNumber: { fontSize: rf(16), lineHeight: rh(22.4) },
  cardDetailsLabel: { fontSize: rf(14), lineHeight: rh(20.3) },
  blockedStatus: {
    color: theme.COLOR_TEXT_CRITICAL,
    fontSize: rf(16),
    lineHeight: rh(22.4),
    textAlign: 'center',
    marginTop: rh(8),
  },
  cardActions: { width: '100%' },
  cardDetailsActions: { width: '100%', marginTop: rh(40) },
  balanceActions: { marginVertical: rh(40) },
  actionItem: { width: rw(52) },
  actionLabel: { width: rw(120), marginHorizontal: -rw(34), textAlign: 'center' },
  actionCircle: { width: rw(52), height: rw(52), borderRadius: rw(26), backgroundColor: theme.COLOR_BG_SURFACE },
  criticalCircle: { backgroundColor: theme.COLOR_BG_CRITICAL_SECONDARY },
  frozenCircle: { backgroundColor: theme.COLOR_BG_INVERSE },
  blockedNumber: { marginTop: rh(32) },
  title: { fontSize: rf(20), lineHeight: rh(26), letterSpacing: rw(-0.2) },
  link: { color: theme.COLOR_TEXT_BRAND, fontSize: rf(16) },
  credential: {
    height: rh(64),
    paddingLeft: rw(16),
    paddingRight: rw(4),
    backgroundColor: theme.COLOR_BG_SURFACE,
    borderRadius: rw(16),
  },
  billingRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  panel: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.COLOR_BG_BASE,
    borderTopLeftRadius: rw(24),
    borderTopRightRadius: rw(24),
    borderWidth: rw(1),
    borderColor: theme.COLOR_STROKE_SECONDARY,
    overflow: 'hidden',
  },
  panelHeader: { height: rh(84), paddingHorizontal: rw(24), paddingTop: rh(32) },
  dragHeader: {
    width: '100%',
    minHeight: rh(84),
    ...Platform.select({ web: { touchAction: 'none' as const, userSelect: 'none' as const } }),
  },
  handleArea: { position: 'absolute', top: 0, left: 0, right: 0, height: rh(24), justifyContent: 'center' },
  handle: { width: rw(40), height: rh(6), borderRadius: rw(20), backgroundColor: theme.COLOR_STROKE_SECONDARY },
  operations: { paddingHorizontal: rw(24), paddingBottom: rh(32) },
}))
